import { render, staticRenderFns } from "./task-set-traffic-manager.vue?vue&type=template&id=7ce20ff2&scoped=true&"
import script from "./task-set-traffic-manager.vue?vue&type=script&lang=js&"
export * from "./task-set-traffic-manager.vue?vue&type=script&lang=js&"
import style0 from "./task-set-traffic-manager.vue?vue&type=style&index=0&id=7ce20ff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce20ff2",
  null
  
)

export default component.exports